export default "/assets/5a1c145d4c724e25ac6e91dc50fc384d.png";